import React from 'react';
import Breadcrumb from './breadcrumb';
import type { BreadcrumbLink } from './breadcrumb';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

interface Props {
  breadcrumbs?: BreadcrumbLink[];
  description?: string | null;
  icon?: FontAwesomeIconProps['icon'];
  imgSrc?: string | null;
  title: string;
}

export default function PageHeaderHeading({ breadcrumbs, description, icon, imgSrc, title }: Props) {
  return (
    <div className={classNames('d-flex align-items-start', imgSrc ? 'gap-4' : 'gap-2')}>
      {imgSrc && <img className="rounded" height={82} src={imgSrc} width={164} />}
      {icon && <div className="d-none d-md-block mt-1"><FontAwesomeIcon icon={icon} size="xl" /></div>}
      <div>
        {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumb links={breadcrumbs} />}
        <h5>{title}</h5>
        {description && <div className="text-muted">{description}</div>}
      </div>
    </div>
  );
}
